module.exports = __webpack_public_path__ + "static/media/fc21.09831999.png";